<template>
    <div>
        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/">
                <icon name="dashboard" class="mr-2 w-4 h-4"
                      :class="isUrl('') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Dashboard</div>
            </Link>
        </div>

        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/brands">
                <icon name="office" class="mr-2 w-4 h-4"
                      :class="isUrl('brands') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('brands') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Brands</div>
            </Link>
        </div>

        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/traffic-sources">
                <icon name="office" class="mr-2 w-4 h-4"
                      :class="isUrl('traffic-sources') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('traffic-sources') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Traffic
                    sources
                </div>
            </Link>
        </div>

        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/customers">
                <icon name="users" class="mr-2 w-4 h-4"
                      :class="isUrl('customers') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('customers') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Customers
                </div>
            </Link>
        </div>

        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/offers">
                <icon name="cheveron-right" class="mr-2 w-4 h-4"
                      :class="isUrl('offers') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('offers') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Packages</div>
            </Link>
        </div>

        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/profile-moderation">
                <icon name="cheveron-right" class="mr-2 w-4 h-4"
                      :class="isUrl('profile-moderation') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('profile-moderation') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">
                    Profile Moderation
                </div>
            </Link>
        </div>

        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/girls">
                <icon name="cheveron-right" class="mr-2 w-4 h-4"
                      :class="isUrl('girls') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('girls') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Girls</div>
            </Link>
        </div>

        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/orders">
                <icon name="cheveron-right" class="mr-2 w-4 h-4"
                      :class="isUrl('orders') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('orders') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Orders</div>
            </Link>
        </div>
        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/story">
                <icon name="cheveron-right" class="mr-2 w-4 h-4"
                      :class="isUrl('story') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('story') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Stories</div>
            </Link>
        </div>
        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/blocker-keywords">
                <icon name="cheveron-right" class="mr-2 w-4 h-4"
                      :class="isUrl('blocker-keywords') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('blocker-keywords') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Blocker keywords</div>
            </Link>
        </div>
        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/blocker-keyword-tags">
                <icon name="cheveron-right" class="mr-2 w-4 h-4"
                      :class="isUrl('blocker-keyword-tags') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('blocker-keyword-tags') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Blocker keyword Tags</div>
            </Link>
        </div>
        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/blocker-keyword-response">
                <icon name="cheveron-right" class="mr-2 w-4 h-4"
                      :class="isUrl('blocker-keyword-response') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('blocker-keyword-response') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Blocker keyword responses</div>
            </Link>
        </div>
        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/blocked-chats">
                <icon name="cheveron-right" class="mr-2 w-4 h-4"
                      :class="isUrl('blocked-chats') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('blocked-chats') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Blocked chats</div>
            </Link>
        </div>
        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/chat-settings">
                <icon name="cheveron-right" class="mr-2 w-4 h-4"
                      :class="isUrl('chat-settings') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('chat-settings') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Chat settings</div>
            </Link>
        </div>
        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/chat-prompts">
                <icon name="cheveron-right" class="mr-2 w-4 h-4"
                      :class="isUrl('chat-prompts') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('chat-prompts') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Chat prompts</div>
            </Link>
        </div>
        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/country">
                <icon name="cheveron-right" class="mr-2 w-4 h-4"
                      :class="isUrl('country') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('country') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Countries</div>
            </Link>
        </div>
        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/affiliates">
                <icon name="cheveron-right" class="mr-2 w-4 h-4"
                      :class="isUrl('affiliates') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('affiliates') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Affiliates</div>
            </Link>
        </div>

        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/api-leads">
                <icon name="cheveron-right" class="mr-2 w-4 h-4"
                      :class="isUrl('api-leads') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('api-leads') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Api Leads</div>
            </Link>
        </div>

        <div class="mb-4">
            <Link class="group flex items-center py-3" href="/requests">
                <icon name="cheveron-right" class="mr-2 w-4 h-4"
                      :class="isUrl('requests') ? 'fill-white' : 'fill-indigo-400 group-hover:fill-white'"/>
                <div :class="isUrl('requests') ? 'text-white' : 'text-indigo-300 group-hover:text-white'">Requests</div>
            </Link>
        </div>

    </div>
</template>

<script>
import {Link} from '@inertiajs/vue3'
import Icon from '@/Shared/Icon'

export default {
    components: {
        Icon,
        Link,
    },
    methods: {
        isUrl(...urls) {
            let currentUrl = this.$page.url.substr(1)
            if (urls[0] === '') {
                return currentUrl === ''
            }
            return urls.filter((url) => currentUrl.startsWith(url)).length
        },
    },
}
</script>
